import {
  EntityInfoPropertyType, EntityInfoSection
} from 'components/shared'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { PERSON_STORE } from 'store'
import { getMainImageSrcForObj, noImageAvatar } from 'utilities'
// import styles from './PersonInfoSection.module.scss'
// import cl from 'classnames'
import { PersonInfoSectionProps } from './PersonInfoSection.types'
import { Image } from 'models'

const PersonInfoSectionComponent = (props: PersonInfoSectionProps) => {
  const {
    [PERSON_STORE]: {
      personToView: person,
      editPerson
    }
  } = props

  const [name, setName] = useState('')
  const [tags, setTags] = useState('')
  const [info, setInfo] = useState('')

  useEffect(() => {
    setName(person.name || '')
    setTags(person.tags || '')
    setInfo(person.info || '')
  }, [person])

  const handleSaveChanges = (images: Image[]) => {
    editPerson({
      ...person.asDTO,
      name,
      tags,
      info,
      images
    })
  }

  const onDiscardChanges = () => {
    setName(person.name || '')
    setTags(person.tags || '')
    setInfo(person.info || '')
  }

  return (
    <EntityInfoSection
      name={name}
      mainImage={getMainImageSrcForObj(person) || noImageAvatar}
      setName={setName}
      saveChanges={handleSaveChanges}
      discardChanges={onDiscardChanges}
      propertyFields={[
        {
          label: 'Tags',
          type: EntityInfoPropertyType.TAGS,
          value: tags,
          onChange: setTags
        },
        {
          label: 'Role',
          type: EntityInfoPropertyType.TEXT,
          value: person.rolesAsString
        }
      ]}
      textareaField={{
        label: 'Description',
        type: EntityInfoPropertyType.TEXT,
        value: info,
        onChange: setInfo
      }}
      images={person.images}
    />
  )

  // return (
  //   <SectionContainer>
  //     <div className={styles.nameContainer}>
  //       <ImagePortrait
  //         width={40}
  //         src={getMainImageSrcForObj(person) || noImageAvatar}
  //         alt={person.name}
  //       />

  //       {editMode
  //         ? (
  //           <>
  //             <Input
  //               className={styles.nameInput}
  //               value={name}
  //               onChange={setName}
  //             />
  //             <Button
  //               preset='secondary'
  //               onClick={() => setEditMode(false)}
  //             >
  //               Discard changes
  //             </Button>
  //             <Button
  //               preset='primary'
  //               onClick={handleSaveChanges}
  //             >
  //               Save changes
  //             </Button>
  //           </>
  //         )
  //         : (
  //           <H1 bold>{person.name}</H1>
  //         )}

  //     </div>

  //     <div className={styles.infoContainer}>
  //       <div className={styles.infoLeftContainer}>
  //         <div className={styles.flexContainer}>
  //           <Text1 style={{ width: 132 }} bold>Tags</Text1>
  //           <div className={styles.tagsContainer}>
  //             {editMode && (
  //               <Input placeholder='Type in a tag, use enter to add the tag' />
  //             )}
  //             {person.tags && person.tags.split(',').map((tag, index) => (
  //               <Tag key={index} tag={tag} />
  //             ))}
  //           </div>
  //         </div>
  //         <div className={styles.flexContainer2}>
  //           <Text1 style={{ width: 132 }} bold>Role</Text1>
  //           <Text1>
  //             {person.rolesAsString}
  //           </Text1>
  //         </div>
  //       </div>
  //       <div className={styles.infoRightContainer}>
  //         <Text1 bold>Description</Text1>

  //         {editMode
  //           ? (
  //             <Textarea
  //               className={styles.textarea}
  //               value={info}
  //               onChange={setInfo}
  //             />
  //           )
  //           : (
  //             <Text1 className={cl(styles.description, styles.scrollable)}>
  //               {person.info}
  //             </Text1>
  //           )}
  //       </div>
  //     </div>

  //     <HorizontalLine />

  //     <Text1 bold style={{ marginTop: 14 }}>Images</Text1>

  //     {editMode
  //       ? (
  //         <GalleryDropZone
  //           ref={imagesRef}
  //           initialImages={person.images || []}
  //         />
  //       )
  //       : (
  //         <div className={styles.imagesContainer}>
  //           {(person.images && person.images.length)
  //             ? person.images.map(image => {
  //               return (
  //                 <ImagePortrait
  //                   key={image.id}
  //                   src={image.url}
  //                   width={94}
  //                 />
  //               )
  //             })
  //             : (
  //               <NoneLabel style={{ marginLeft: 12 }} />
  //             )}
  //         </div>
  //       )}

  //     {
  //       !editMode && (
  //         <Button
  //           preset='icon'
  //           className={styles.editButton}
  //           onClick={() => setEditMode(true)}
  //         >
  //           <IconEdit />
  //         </Button>
  //       )
  //     }
  //   </SectionContainer >
  // )
}

const PersonInfoSection = inject(
  PERSON_STORE
)(observer(PersonInfoSectionComponent))
export { PersonInfoSection }
